import { concatUrl } from "./common";
import { rokidAccountBaseUrl } from "@rokid/host";
import type { ISSEConfig } from "./request.d";

function getCookieItem(sKey) {
  return (
    decodeURIComponent(
      document.cookie.replace(
        new RegExp(
          "(?:(?:^|.*;)\\s*" +
            encodeURIComponent(sKey).replace(/[-.+*]/g, "\\$&") +
            "\\s*\\=\\s*([^;]*).*$)|^.*$"
        ),
        "$1"
      )
    ) || null
  );
}
/**
 * @type TParams 传入参数类型
 * @type TData 函数返回类型
 */
export async function requestSSE<TParams = Record<string, any>, TResult = any>(
  config: ISSEConfig<TParams>
) {
  const defaultConfig: ISSEConfig<TParams> = {
    method: "get",
    credentials: "include",
    postWithQuery: false,
  };

  let headers = {
    "Content-Type": "application/json",
    ...(config.headers || {}),
    access_token: "",
  };
  if (config.needToken) {
    headers.access_token = getCookieItem("ROKID_ACCOUNT_SESSION") || "";
  } else {
    delete headers.access_token;
  }
  const newConfig: ISSEConfig<TParams> = Object.assign(
    {},
    defaultConfig,
    config
  );
  newConfig.headers = headers;
  const {
    method = "post",
    params,
    data,
    postWithQuery,
    onStart,
    onMessage,
    onEnd,
  } = newConfig;
  let { url } = newConfig;
  if (method.toLowerCase() === "get" || postWithQuery) {
    url =
      params && Object.keys(params).length > 0
        ? `${url}?${concatUrl(params)}`
        : url;
  }
  if (method.toLowerCase() === "post" || method.toLowerCase() === "put") {
    newConfig.body = JSON.stringify(data);
  }
  if (!url) {
    return Promise.reject("未传入URL，请检查传递参数！");
  }
  return fetch(url, newConfig).then(
    async (response) => {
      if (response.status !== 200) {
        return Promise.reject(response);
      }
      onStart && onStart();
      // 读取服务器的流式响应（模拟 SSE）
      const reader = response.body?.getReader();
      if (!reader) {
        return Promise.reject("web stream reader 不存在");
      }
      const decoder = new TextDecoder("utf-8");
      // 缓存未完整解析的消息（避免流式数据分片导致解析异常）
      let leftoverData = "";
      // 循环读取流式数据（直到连接关闭）
      while (true) {
        const { done, value } = await reader.read();
        //  解码二进制数据为字符串
        const newData = decoder.decode(value, { stream: true });
        // 合并缓存数据 + 新读取的数据
        const fullData = leftoverData + newData;
        // 按 SSE 消息分隔符（\n\n）分割多条消息
        const messageChunks = fullData.split("\n\n");
        // 缓存最后一个不完整的消息（可能后续还有数据拼接）
        leftoverData = messageChunks.pop() || "";
        // 遍历解析完整的 SSE 消息
        for (const chunk of messageChunks) {
          onMessage && onMessage(chunk);
        }
        // 连接已关闭（done = true）
        if (done) {
          onEnd && onEnd();
          break;
        }
      }
    },
    (ex) => {
      throw new Error(`请求服务器出错:${url} ${ex.message}`);
    }
  );
}
